import cx from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { handleStickyScroll } from '@tesla/design-system';
export const InternalHeader = ({ className, headerRef, leading, search, trailing, skipNavLabel, skipNavHref, ...rest }) => {
    if (skipNavHref && !skipNavLabel) {
        console.warn('`skipNavLabel` and `skipNavHref` must both be defined if a skip link is desired');
    }
    // Wire up stuck-ness to state so that when component re-renders the --stuck class is not lost
    const [isStuck, setIsStuck] = useState(false);
    const fallbackRef = useRef(null);
    const ref = headerRef !== null && headerRef !== void 0 ? headerRef : fallbackRef;
    useEffect(() => {
        if (ref.current) {
            const onStickyChange = (shouldBeStuck) => {
                setIsStuck(shouldBeStuck);
            };
            return handleStickyScroll(ref.current, { onStickyChange });
        }
        return () => undefined;
    }, [ref]);
    return (React.createElement("header", { className: cx('tds-site-header', 'tds-site-header--internal', 'tds-site-header--sticky', {
            'tds-site-header--stuck': isStuck,
        }, 'tds-density--dense', className), id: "tds-site-header", ref: ref, ...rest },
        skipNavHref && (React.createElement("a", { className: "tds-skip-to-content tds--is_visually_hidden", href: skipNavHref, id: "top-of-page" }, skipNavLabel)),
        React.createElement("div", { className: "tds-site-header-leading tds-align--start" }, leading),
        search && React.createElement("div", { className: "tds-site-header-search tds-align--center" }, search),
        React.createElement("div", { className: "tds-site-header-trailing tds-align--end" }, trailing)));
};
